export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14807.70d2a629.jpg";